(function () {
  /**
   * @deprecated not required in ES6 code
   */
  // eslint-disable-next-line angular/window-service
  angular.module('binky.core.src2-migration').constant('binkySrc2', window.binkySrc2);
})();
